import { render, staticRenderFns } from "./ViewProof.vue?vue&type=template&id=784a72f9&scoped=true"
import script from "./ViewProof.vue?vue&type=script&lang=js"
export * from "./ViewProof.vue?vue&type=script&lang=js"
import style0 from "./ViewProof.vue?vue&type=style&index=0&id=784a72f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784a72f9",
  null
  
)

export default component.exports